import { COLUMNS } from "./constants";
import { ColumnName, CustomColumn } from "./types";

export const getDentalPPOCustomColumn = (): CustomColumn => ({
  column: COLUMNS.DENTAL_PLAN_NAME,
  skipHeaderValidation: true,
  getCustomValue: () => ({ text: "Single PPO" }),
});

export const getDentalHMOCustomColumn = (): CustomColumn => ({
  column: COLUMNS.DENTAL_PLAN_NAME,
  skipHeaderValidation: true,
  getCustomValue: () => ({ text: "HMO" }),
});

export const getVisionSingleVisionCustomColumn = (): CustomColumn => ({
  column: COLUMNS.VISION_PLAN_NAME,
  skipHeaderValidation: true,
  getCustomValue: () => ({ text: "Single Vision" }),
});

export const getEligibilityClassCustomColumn = (): CustomColumn => ({
  column: COLUMNS.ELIGIBILITY_CLASS,
  skipHeaderValidation: true,
  getCustomValue: () => ({ text: "Class 1" }),
});

export const getMultOptionsCustomColumn = (
  column: ColumnName,
  values: Record<string, string>,
): CustomColumn => ({
  column,
  getCustomValue: (val) => {
    if (!val) {
      return { text: "", address: "", type: 3 };
    }

    const value = values[val.text.toLocaleLowerCase()];
    if (value) {
      return { text: value };
    }

    return val;
  },
});
